module.exports = __webpack_public_path__ + "img/administrationOFF.398e9c0c.png";